import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function ListEditor({ items, onChange, fields, addLabel, testId, low }) {
  const set = (i, k, v) => onChange(items.map((it, idx) => (idx === i ? { ...it, [k]: v } : it)));
  return (
    <div className="space-y-2" data-testid={testId}>
      {items.map((it, i) => (
        <div key={i} className={`grid gap-2 rounded-[6px] border p-3 sm:grid-cols-2 ${low ? "border-[#D9BE85] bg-caution-tint/40" : "border-line bg-white"}`} data-testid={`${testId}-item-${i}`}>
          {fields.map(([k, label]) => (
            <Input key={k} value={it[k] || ""} onChange={(e) => set(i, k, e.target.value)} placeholder={label} aria-label={`${label} ${i + 1}`}
              className="h-9 bg-white" data-testid={`${testId}-${i}-${k}`} />
          ))}
          <Button type="button" variant="ghost" size="sm" className="w-fit text-ink-muted hover:text-risk sm:col-span-2" onClick={() => onChange(items.filter((_, idx) => idx !== i))}
            data-testid={`${testId}-remove-${i}`}><Trash2 size={14} aria-hidden="true" /> Remove</Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => onChange([...items, {}])} data-testid={`${testId}-add`}><Plus size={14} aria-hidden="true" /> {addLabel}</Button>
    </div>
  );
}
